<template>
    <div class="card-item">
        <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">
            <img v-if="post.acf.has_main_image" class='card-image' :src="post.acf.main_image.sizes.medium" :alt="post.acf.main_image.alt" />
            <p class="my-2">
                <span class="my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter">
                    {{ display_date }}                    
                </span>
                <br />
                <a :href="post.link" class="card-item__title">{{ title }}</a>                                        
            </p>                                        
            <div class="card-item__summary">
                <span>{{ summary }}</span> <a :href='post.link'>Read More&raquo; </a>
            </div>
        </article>
    </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'ml-card',
  props: ['post'],
  data() {
    return {
      summary: '',      
      display_date: ''
    }
  },
  computed: {
    title() {
      return this.post.post_title || this.post.title.rendered
    }
  },
  methods: {
    makeSummary() {
        let excerptSource = this.post.excerpt && this.post.excerpt.rendered ? this.post.excerpt.rendered : this.post.content.rendered;

        const $htmlHolder = $('<div />')

        const contentPreview =
            excerptSource
            .split(' ')
            .splice(0, 15)
            .join(' ') + '...'

        $htmlHolder.html(contentPreview)

        this.summary = $htmlHolder.text()      
    },
    addDisplayDate() {
      this.display_date = format(this.post.date, 'MMM D, YYYY')
    },
    updateMeta() {      
      this.addDisplayDate()
      this.makeSummary()
    }
  },
  updated() {
    this.updateMeta()
  },
  created() {
    this.updateMeta()
  }
}
</script>



// WEBPACK FOOTER //
// src/js/vue-components/ml-card.vue